import { render } from "./MenuTab.vue?vue&type=template&id=ee5e390a&scoped=true"
import script from "./MenuTab.vue?vue&type=script&lang=ts"
export * from "./MenuTab.vue?vue&type=script&lang=ts"

import "./MenuTab.vue?vue&type=style&index=0&id=ee5e390a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ee5e390a"

export default script